var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};

site.eventCategoryDefault = {
	init: function () {
		if($('#CalendarSubmitEventForm').length > 0) {
			$('#fieldset-categoryIds input#categoryIds-2').prop('checked', true);
		}
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.helpful = {
	view: function () {
		var $helpful = $('.helpfulWrap');
		$helpful.responsiveDom({
			appendTo: '#contentContainer > .contentWrap',
			mediaQuery: 'screen and (max-width: 991px)',
		});
	}
};

site.dropdown = {
	init: function () {
		site.dropdown.setHeight();
		$(window).resize(function() {
			site.dropdown.setHeight();
		});

		$('a.special+ul','#btns').on('click', function(e) {
			e.stopPropagation();
		});

		$('a.special', '#btns').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			var $this = $(this),
				$body = $('body');


			if (!$this.hasClass('open')) {
				$('#btns').find('a.special').removeClass('open');
				$this.addClass('open');
				$body.addClass('dropdown-open');
			}
			else {
				$this.removeClass('open');
			}

			$('body.dropdown-open').on('click', function () {
				site.dropdown.close();
			});
		});
	},

	setHeight:function() {
		var $dropdown = $('a.special+ul', '#btns');
		$($dropdown).each(function() {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
	},

	close:function() {
		$('a.special','#btns').removeClass('open');
		setTimeout(function() {
			$('body').removeClass('dropdown-open');
		},400);
	}
};

site.boxtiny = {
	init: function() {
		$("ul > li a[href$='.pdf']", ' .box_tiny').each(function() {
			$(this).closest('li').addClass('pdf');
		});

		$("ul > li a[href^='http']", '.box_tiny').each(function() {
			$(this).closest('li').addClass('http');
		});
		$("ul > li a[href^='.doc']", '.box_tiny').each(function() {
			$(this).closest('li').addClass('doc');
		});
		$("ul > li a[href^='.ppt']", '.box_tiny').each(function() {
			$(this).closest('li').addClass('ppt');
		});
		$("ul > li a[href^='xls']", '.box_tiny').each(function() {
			$(this).closest('li').addClass('xls');
		});
		$("ul > li a[href^='/']", '.box_tiny').each(function() {
			$(this).closest('li').addClass('link');
		});
	}
};

site.placeholder = {
	init: function () {
		$('#newsFilter .years .lmnt #years').attr('aria-label', 'Velja ár');
		$('#newsFilter .months .lmnt #months').attr('aria-label', 'Velja mánuð');
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.carouselImg = {
	init: function () {
		var $count = $("#banner_wrapper").find('li');
		if ($count.length < 2){
			$count.each(function () {
				$(this).closest('li').addClass('singleImg');
			})
		}

	}
};

site.frontpage = {
	init: function() {
		site.frontpage.scroll();
	},

	scroll: function() {
		$('span.scroll span', '.box.scroll').on('click', function() {
			var target = $(this).parents('.box').next();
			var offset = 70;
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top-offset
				}, 1000);
				return false;
			}

		});
	}
};

site.activityFilter = {
	init: function() {
		const searchBox = document.getElementById('filter-Search');
		const icons = document.querySelectorAll('.items .item');
		const suggestions = document.getElementById('suggestions');
		searchBox.addEventListener('input', function (e) {
			icons.forEach(icon => {
				if (icon.dataset.text.includes(searchBox.value.toLowerCase())) {
					icon.style.removeProperty('display');
					//console.log(icon.dataset);
				} else {
					icon.style.display = 'none';
				}
			});
		});

		const wait = async (callback, time) => {
			return new Promise(resolve => {
				setTimeout(() => {
					resolve(callback());
				}, time);
			});
		};
	}
}

moya = window.moya || {};
moya.boxman = moya.boxman || {};
moya.boxman = $.extend(moya.boxman, {
	addClass: function (className) {
		var $class = $('#class');
		if ($class.val().indexOf(className) === -1) {
			var space = ($class.val().length === 0) ? '' : ' ';
			$class.val($class.val() + space + className);
		}
	}
});

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.eventCategoryDefault.init();
	site.mMenu.init();
	site.accessibility.init();
	site.boxtiny.init();
	site.megamenu.init();
	site.placeholder.init();
	site.helpful.view();
	site.carouselImg.init();
	site.meetingBoxes.init();


	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
		site.dropdown.init();
	}
	if ($body.is('.ferdathjonusta.activities')) {
		site.activityFilter.init();
	}

	$frontOwlSettings = {
		items: 1,
		nav: false,
		autoHeight: false,
		dots: true,
		autoplay: false,
		loop: true,
		autoplayTimeout:7000,
		smartSpeed: 1000
	};

	if ($body.is('.frontpage') && $('.img_carousel').length > 1) {
		site.owl.init('#banner_wrapper ul', $frontOwlSettings);

		$('#banner_wrapper .owl-dots .owl-dot').on('click', function(e) {
			var carousel = $('#banner_wrapper .owl-carousel');
			carousel.trigger('stop.owl.autoplay');
			carousel.trigger('play.owl.autoplay');
			})

	}


	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}



	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
